export class CustomEnum {
  constructor(
    public value: any,
    public label: any
  ) {}

  static stringToValue(str: string, clazz: any): CustomEnum {
    const values: CustomEnum[] = Object.values(clazz);
    if (values.find((x: CustomEnum) => x.label === str)) {
      return values.find((x: CustomEnum) => x.label === str);
    }
    return null;
  }

  static getByValue(str: string | number): CustomEnum {
    const values: CustomEnum[] = Object.values(this);
    if (values.find((x: CustomEnum) => x.value === str)) {
      return values.find((x: CustomEnum) => x.value === str);
    }
    return null;
  }

  static getAllValues(): Array<any> {
    return Object.values(this).filter(
      (paymentMethod, i, allPaymentsMethods) =>
        allPaymentsMethods.findIndex(pm => pm.EqualsTo(paymentMethod)) === i
    );
  }

  EqualsTo(target: CustomEnum) {
    if (!target) {
      return false;
    }
    return this.value === target.value && typeof this === typeof target;
  }

  ValueEqualsTo(value: any) {
    return this.value === value && typeof this.value === typeof value;
  }

  toString() {
    return String(this.label);
  }

  valueToString() {
    return this.value.toString();
  }
}
